// extracted by mini-css-extract-plugin
module.exports = {"button":"AnchorHead-module--button--3i2Dd"};